import { useEffect, useRef } from 'react';

import { setUserContactData } from './brazeClient';

export function useBrazeUserSync(email?: string | null, phone?: string | null) {
  const syncedRef = useRef(false);

  useEffect(() => {
    if (!email && !phone) return;
    if (!window?.braze) return;

    if (syncedRef.current) return;

    setUserContactData(email ?? undefined, phone ?? undefined);
    syncedRef.current = true;
  }, [email, phone]);
}
